module.exports = __webpack_public_path__ + "static/media/g.436da01e.svg";